// Import Foundation 
//import 'script-loader!what-input/dist/what-input';
//import 'script-loader!foundation-sites/dist/js/foundation';

// Import Swiper
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, Autoplay]);

// Import the apps styles
import sass from '../scss/app.scss'

// Import our modules
//import './modules/_header.js'



// Foundation init
jQuery(function () {
	$ = jQuery


	$('#menu-button').on('click', function () {
		$('body').toggleClass('open-menu');
		return false;
	});

	// Close mobile menu when clicking outside the header
	$(document).on('click', function(e) {
		if ( $('body').hasClass('open-menu') && !$(e.target).closest('#header').length ) {
			$('body').removeClass('open-menu');
		}
	});

	// Mobile accordion nav — inject toggle buttons next to each expandable link
	var chevronSvg = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

	$('.header-nav .menu-item-has-children').each(function() {
		var $li = $(this);
		var $btn = $('<button class="nav-toggle" aria-expanded="false" aria-label="Toggle submenu">' + chevronSvg + '</button>');
		$li.children('a').after($btn);
		$btn.on('click', function(e) {
			e.stopPropagation();
			var open = $li.toggleClass('is-open').hasClass('is-open');
			$btn.attr('aria-expanded', String(open));
			// Collapse siblings
			$li.siblings('.is-open').each(function() {
				$(this).removeClass('is-open').find('.nav-toggle').attr('aria-expanded', 'false');
			});
		});
	});

	var subChevronSvg = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

	$('.dropdown-col-group').each(function() {
		var $group = $(this);
		if ( !$group.find('.third-level').length ) return;
		var $btn = $('<button class="nav-toggle nav-toggle--sub" aria-expanded="false" aria-label="Toggle submenu">' + subChevronSvg + '</button>');
		$group.children('a').after($btn);
		$btn.on('click', function(e) {
			e.stopPropagation();
			var open = $group.toggleClass('is-open').hasClass('is-open');
			$btn.attr('aria-expanded', String(open));
		});
	});


	$('#landing-arrow').on('click', function () {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#header").offset().top
		}, 2000);
	});



	var landing = $('#landing-holder');

	var landingSet = sessionStorage.getItem('landing-on');

	console.log(landingSet);
	if (!landingSet) {
		ShowLanding();
		bindScroll();
	}

	function ShowLanding() {
		//landing.css('height', $(window).height());
		console.log('showlanding');
		setTimeout(function () { window.scrollTo(0, 0); }, 15);
	}

	//Binds Scroll Event to Browser Window
	function bindScroll() {
		console.log("bind scroll")
		$(window).scroll(function (e) {
			setScrollTimer();
		});
	}
	//Sets Timeout to limit the amount of Scroll Events taking place to improve performance	
	var i = 0;
	var rolledUp = false;
	function setScrollTimer() {
		//unbindScroll();
		var scrollPos = $(window).scrollTop();
		checkHeaderFixed(scrollPos);
		//i++;
		//console.log(scrollPos);
		//logoText.css('bottom',scrollPos/2);
		//var scrollTimer = window.setTimeout(function(){bindScroll()}, 1);
	}

	//Unbinds Scroll Event
	function unbindScroll() {
		$(window).unbind('scroll');
	}




	//Toggles Between Header States
	function checkHeaderFixed(scrollPos) {
		const headerEl = document.querySelector('#header');

		console.log(headerEl.offsetTop);
		//Masthead
		if (scrollPos >= headerEl.offsetTop && !rolledUp) {
			removeLanding();
		}
		if ($(window).scrollTop() + $(window).height() == $(document).height()) {
			removeLanding();
		}
	}



	function removeLanding() {
		$('body').removeClass('landing-on');
		setTimeout(function () { window.scrollTo(0, 0); }, 15);
		rolledUp = true;
		unbindScroll();
		sessionStorage.setItem('landing-on', 'true');
	}

	// Subscribe to the WooCommerce Blocks cart store so the badge updates automatically
	// whenever the Cart Block adds, removes, or changes item quantities.
	if ( window.wp && window.wp.data ) {
		var cartBadgePrevCount = null;
		wp.data.subscribe( function () {
			var store = wp.data.select( 'wc/store/cart' );
			if ( ! store ) return;
			var cartData = store.getCartData();
			if ( ! cartData ) return;
			// Store API returns snake_case; Blocks may normalise to camelCase — handle both.
			var count = cartData.items_count !== undefined ? cartData.items_count : ( cartData.itemsCount || 0 );
			if ( count === cartBadgePrevCount ) return;
			cartBadgePrevCount = count;
			var badge = document.querySelector( 'span.cart-count' );
			if ( ! badge ) return;
			badge.textContent = count;
			badge.classList.toggle( 'is-empty', count === 0 );
		} );
	}

	// Mobile sidebar filter drawer
	var $filterToggle = $('#filter-toggle-btn');
	var $sidebarClose = $('.sidebar-close-btn');
	if ( $filterToggle.length ) {
		var $backdrop = $('<div class="sidebar-backdrop"></div>');
		$('body').append($backdrop);

		function openSidebar() {
			$('body').addClass('sidebar-open');
			$filterToggle.attr('aria-expanded', 'true');
		}
		function closeSidebar() {
			$('body').removeClass('sidebar-open');
			$filterToggle.attr('aria-expanded', 'false');
		}

		$filterToggle.on('click', function() {
			$('body').hasClass('sidebar-open') ? closeSidebar() : openSidebar();
		});
		$sidebarClose.on('click', closeSidebar);
		$backdrop.on('click', closeSidebar);

		// Close on Escape key
		$(document).on('keydown', function(e) {
			if ( e.key === 'Escape' && $('body').hasClass('sidebar-open') ) closeSidebar();
		});
	}

	// Product sidebar attribute filters — navigate on change, preserving other active filters
	$(document).on('change', '.sidebar-filter-select', function () {
		var url    = new URL(window.location.href);
		var param  = $(this).data('param');
		var value  = $(this).val();

		if (value) {
			url.searchParams.set(param, value);
		} else {
			url.searchParams.delete(param);
		}
		url.searchParams.delete('paged');

		window.location.href = url.toString();
	});

	// Select2 is only enqueued on product archives
	if ( $.fn.select2 ) $('.sidebar-filter-select').select2({
		theme: 'default',
		width: '100%',
		dropdownCssClass: 'product-sidebar-dropdown',
		placeholder: function() {
			return $(this).data('placeholder') || '';
		},
		allowClear: false,
		minimumResultsForSearch: Infinity,
	});

	// Instant product search (header + sidebar)
	var INSTANT_SEARCH_DEBOUNCE  = 250;  // wait after last keystroke
	var INSTANT_SEARCH_MAX_WAIT  = 600;  // but never delay longer than this
	var INSTANT_SEARCH_MIN_CHARS = 2;
	var INSTANT_SEARCH_CACHE_MAX = 50;
	var INSTANT_SEARCH_MAX_SHOWN = 6;

	document.querySelectorAll('.instant-search').forEach(function (root) {
		var endpoint = root.dataset.endpoint;
		var input     = root.querySelector('.instant-search-input');
		var form      = root.querySelector('.instant-search-form');
		var results   = root.querySelector('.instant-search-results');
		var closeBtn  = root.querySelector('.instant-search-close');
		if (!endpoint || !input || !results) return;

		var isHeader = root.classList.contains('instant-search--header');
		var debounceTimer;
		var maxWaitTimer;
		var pendingTerm   = '';
		var lastTerm      = '';
		var controller;
		var cache         = new Map();

		function openOverlay() {
			if (!isHeader) return;
			root.classList.add('is-open');
			document.body.classList.add('search-overlay-open');
		}

		function closeOverlay() {
			if (!isHeader) return;
			root.classList.remove('is-open');
			document.body.classList.remove('search-overlay-open');
		}

		function removeMoreLink() {
			Array.prototype.forEach.call(
				root.querySelectorAll('.instant-search-more'),
				function (n) { n.remove(); }
			);
		}

		function hide() {
			results.hidden = true;
			results.innerHTML = '';
			removeMoreLink();
		}

		function showLoading() {
			results.innerHTML = '<div class="instant-search-loading" role="status" aria-live="polite"><span class="instant-search-spinner" aria-hidden="true"></span><span class="screen-reader-text">Searching…</span></div>';
			results.hidden = false;
			removeMoreLink();
		}

		function render(items, term) {
			removeMoreLink();
			if (!items.length) {
				results.innerHTML = '<div class="instant-search-empty">No matching products.</div>';
				results.hidden = false;
				return;
			}
			var hasMore = items.length > INSTANT_SEARCH_MAX_SHOWN;
			var shown   = hasMore ? items.slice(0, INSTANT_SEARCH_MAX_SHOWN) : items;
			var html = shown.map(function (item) {
				var img       = item.image ? '<img src="' + item.image + '" alt="" />' : '<span class="instant-search-thumb-placeholder"></span>';
				var brandLogo = item.brand_logo ? '<img class="instant-search-brand-logo" src="' + item.brand_logo + '" alt="' + item.brand + '" />' : '';
				var brand     = item.brand ? '<span class="instant-search-brand">' + item.brand + '</span>' : '';
				var price     = item.price ? '<span class="instant-search-price">' + item.price + '</span>' : '';
				var sku       = item.sku   ? '<span class="instant-search-sku">SKU: ' + item.sku + '</span>' : '';
				var cats      = '';
				if (item.categories && item.categories.length) {
					cats = '<div class="instant-search-category">'
						+ item.categories.map(function (c, i, arr) { return '<span>' + c + (i < arr.length - 1 ? ',' : '') + '</span>'; }).join('')
						+ '</div>';
				}
				return '<a class="instant-search-result" href="' + item.url + '" role="option">'
					+ '<span class="instant-search-thumb">' + img + '</span>'
					+ '<span class="instant-search-meta">'
					+   brandLogo
					+   '<span class="instant-search-title">' + item.title + '</span>'
					+   sku
					+   cats
					+ '</span>'
					+ '</a>';
			}).join('');
			results.innerHTML = html;
			results.hidden = false;
			if (hasMore && form && term) {
				var moreUrl = form.action
					+ (form.action.indexOf('?') === -1 ? '?' : '&')
					+ 's=' + encodeURIComponent(term)
					+ '&post_type=product';
				var moreLink = document.createElement('a');
				moreLink.className = 'instant-search-more';
				moreLink.href = moreUrl;
				moreLink.textContent = 'View More Results';
				results.insertAdjacentElement('afterend', moreLink);
			}
		}

		function cachePut(term, items) {
			if (cache.has(term)) cache.delete(term);
			cache.set(term, items);
			if (cache.size > INSTANT_SEARCH_CACHE_MAX) {
				cache.delete(cache.keys().next().value);
			}
		}

		function fire() {
			clearTimeout(debounceTimer);
			clearTimeout(maxWaitTimer);
			maxWaitTimer = null;
			var term = pendingTerm;
			if (!term || term.length < INSTANT_SEARCH_MIN_CHARS) return;
			if (term === lastTerm) return;
			lastTerm = term;

			if (cache.has(term)) {
				if (controller) controller.abort();
				render(cache.get(term), term);
				return;
			}

			if (controller) controller.abort();
			controller = new AbortController();
			var signal = controller.signal;
			showLoading();
			fetch(endpoint + '?q=' + encodeURIComponent(term), { signal: signal })
				.then(function (r) { return r.json(); })
				.then(function (items) {
					cachePut(term, items);
					// Only render if this response is still the latest term requested.
					if (term === pendingTerm) render(items, term);
				})
				.catch(function (err) {
					if (err.name !== 'AbortError') hide();
				});
		}

		input.addEventListener('input', function () {
			var term = input.value.trim();
			pendingTerm = term;

			if (term.length < INSTANT_SEARCH_MIN_CHARS) {
				clearTimeout(debounceTimer);
				clearTimeout(maxWaitTimer);
				maxWaitTimer = null;
				lastTerm = '';
				if (controller) controller.abort();
				hide();
				return;
			}

			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(fire, INSTANT_SEARCH_DEBOUNCE);
			if (!maxWaitTimer) {
				maxWaitTimer = setTimeout(fire, INSTANT_SEARCH_MAX_WAIT);
			}
		});

		input.addEventListener('focus', function () {
			openOverlay();
			var term = input.value.trim();
			if (term.length < INSTANT_SEARCH_MIN_CHARS) return;
			if (cache.has(term)) {
				pendingTerm = term;
				lastTerm    = term;
				render(cache.get(term), term);
			} else if (results.innerHTML) {
				results.hidden = false;
			}
		});

		document.addEventListener('click', function (e) {
			if (!root.contains(e.target)) {
				hide();
				closeOverlay();
			}
		});

		// Click on overlay backdrop (outside form/results/close) closes the overlay.
		root.addEventListener('mousedown', function (e) {
			if (!isHeader || !root.classList.contains('is-open')) return;
			if (form && form.contains(e.target)) return;
			if (results && results.contains(e.target)) return;
			if (closeBtn && closeBtn.contains(e.target)) return;
			if (e.target.closest('.instant-search-more')) return;
			hide();
			closeOverlay();
			input.blur();
		});

		input.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') { hide(); closeOverlay(); input.blur(); }
		});

		if (closeBtn) {
			closeBtn.addEventListener('click', function () {
				hide();
				closeOverlay();
				input.blur();
			});
		}
	});

	// Sidebar search proxy — focus redirects to the header instant-search input
	var sidebarProxy = document.querySelector('.sidebar-search-proxy');
	if (sidebarProxy) {
		sidebarProxy.addEventListener('focus', function () {
			var headerInput = document.querySelector('.instant-search--header .instant-search-input');
			if (headerInput) {
				sidebarProxy.blur();
				headerInput.focus();
			}
		});
	}

	// Related products slider
	if ( document.querySelector('.related-products-swiper') ) {
		new Swiper('.related-products-swiper', {
			slidesPerView: 2,
			spaceBetween: 10,
			navigation: {
				nextEl: '.related-swiper-next',
				prevEl: '.related-swiper-prev',
			},
			pagination: {
				el: '.related-swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				1150: {
					slidesPerView: 4,
					spaceBetween: 30,
				},
			},
		});
	}

	// Initialize Swiper for homepage slideshow
	var homeSwiperEl = document.querySelector('.mySwiper');
	if ( homeSwiperEl ) {
		var homeSlideCount = homeSwiperEl.querySelectorAll('.swiper-slide').length;
		var homeInitialSlide = homeSlideCount > 1 ? Math.floor(Math.random() * homeSlideCount) : 0;
		new Swiper('.mySwiper', {
			direction: 'horizontal',
			loop: true,
			initialSlide: homeInitialSlide,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			scrollbar: {
				el: '.swiper-scrollbar',
			},
		});
	}

	// ── Lightbox ────────────────────────────────────────────────────────────────
	function openLightbox(items, startIndex) {
		var index = startIndex || 0;

		var overlay = document.createElement('div');
		overlay.className = 'lightbox-overlay';

		var closeBtn = document.createElement('button');
		closeBtn.className = 'lightbox-close';
		closeBtn.setAttribute('aria-label', 'Close');
		closeBtn.innerHTML = '&times;';

		var img = document.createElement('img');
		img.className = 'lightbox-image';

		var cap = document.createElement('div');
		cap.className = 'lightbox-caption';

		overlay.appendChild(closeBtn);

		if (items.length > 1) {
			var prevBtn = document.createElement('button');
			prevBtn.className = 'lightbox-prev';
			prevBtn.setAttribute('aria-label', 'Previous image');
			prevBtn.innerHTML = '&#8592;';

			var nextBtn = document.createElement('button');
			nextBtn.className = 'lightbox-next';
			nextBtn.setAttribute('aria-label', 'Next image');
			nextBtn.innerHTML = '&#8594;';

			overlay.appendChild(prevBtn);
			overlay.appendChild(nextBtn);

			prevBtn.addEventListener('click', function(e) { e.stopPropagation(); go(index - 1); });
			nextBtn.addEventListener('click', function(e) { e.stopPropagation(); go(index + 1); });
		}

		overlay.appendChild(img);
		overlay.appendChild(cap);
		document.body.appendChild(overlay);
		document.body.style.overflow = 'hidden';

		function go(i) {
			index = (i + items.length) % items.length;
			img.src = items[index].src;
			cap.textContent = items[index].caption;
			cap.style.display = items[index].caption ? '' : 'none';
		}

		go(index);

		function close() {
			overlay.remove();
			document.body.style.overflow = '';
			document.removeEventListener('keydown', onKey);
		}

		function onKey(e) {
			if (e.key === 'Escape') close();
			if (items.length > 1 && e.key === 'ArrowLeft')  go(index - 1);
			if (items.length > 1 && e.key === 'ArrowRight') go(index + 1);
		}

		closeBtn.addEventListener('click', close);
		overlay.addEventListener('click', function(e) {
			if (e.target === overlay) close();
		});
		document.addEventListener('keydown', onKey);
	}

	// WooCommerce product gallery
	$(document).on('click', '.woocommerce-product-gallery__image a', function(e) {
		e.preventDefault();
		var $links = $('.woocommerce-product-gallery__image a');
		var items  = $links.map(function() {
			return { src: $(this).attr('href'), caption: $(this).find('img').attr('alt') || '' };
		}).get();
		var startIndex = $links.index(this);
		openLightbox(items, startIndex);
	});

	// Legacy custom gallery blocks
	$(document).on('click', '.custom-gallery-lightbox figure img', function(e) {
		e.preventDefault();
		var imgSrc  = $(this).attr('src');
		var caption = $(this).closest('figure').find('figcaption').text() || '';
		openLightbox([{ src: imgSrc, caption: caption }], 0);
	});

	// Auto-scroll + drag-to-scroll for ticker-style carousels.
	// Markup contract: an outer scrolling container with a track inside whose items
	// are duplicated so half the scrollWidth is the seamless-loop point.
	function initDragTicker(container, trackSelector, speed) {
		var track = container.querySelector(trackSelector);
		if (!track) return;

		var auto        = true;
		var lastTime    = 0;
		var resumeTimer = null;
		var isDragging  = false;
		var startX      = 0;
		var startScroll = 0;
		var moved       = false;

		function loopPoint() { return track.scrollWidth / 2; }

		function step(now) {
			if (lastTime && auto && !isDragging) {
				container.scrollLeft += speed * (now - lastTime);
				var half = loopPoint();
				if (half > 0 && container.scrollLeft >= half) {
					container.scrollLeft -= half;
				}
			}
			lastTime = now;
			requestAnimationFrame(step);
		}
		requestAnimationFrame(step);

		container.addEventListener('mouseenter', function () { auto = false; });
		container.addEventListener('mouseleave', function () { if (!isDragging) auto = true; });

		container.addEventListener('mousedown', function (e) {
			isDragging  = true;
			moved       = false;
			startX      = e.pageX;
			startScroll = container.scrollLeft;
			container.classList.add('is-dragging');
			e.preventDefault();
		});

		document.addEventListener('mousemove', function (e) {
			if (!isDragging) return;
			var dx = e.pageX - startX;
			if (Math.abs(dx) > 3) moved = true;
			container.scrollLeft = startScroll - dx;
			var half = loopPoint();
			if (half > 0) {
				if (container.scrollLeft >= half) container.scrollLeft -= half;
				if (container.scrollLeft < 0)     container.scrollLeft += half;
			}
		});

		function endDrag() {
			if (!isDragging) return;
			isDragging = false;
			container.classList.remove('is-dragging');
			clearTimeout(resumeTimer);
			resumeTimer = setTimeout(function () { auto = true; }, 1500);
		}
		document.addEventListener('mouseup', endDrag);
		document.addEventListener('mouseleave', endDrag);

		// Suppress click after drag so links inside the ticker don't fire on release
		container.addEventListener('click', function (e) {
			if (moved) {
				e.preventDefault();
				e.stopPropagation();
				moved = false;
			}
		}, true);

		container.addEventListener('touchstart', function () { auto = false; }, { passive: true });
		container.addEventListener('touchend',   function () {
			clearTimeout(resumeTimer);
			resumeTimer = setTimeout(function () { auto = true; }, 1500);
		});
	}

	$('.brand-ticker').each(function ()       { initDragTicker(this, '.brand-ticker__track', 0.04); });
	$('.ws-reviews__viewport').each(function () { initDragTicker(this, '.ws-reviews__track', 0.06); });

	// FAQ <details> open/close — animate the .faq-answer height instead of snapping.
	$(document).on('click', '.faq-item > summary', function (e) {
		var item   = this.parentNode;
		var answer = item.querySelector('.faq-answer');
		if (!answer) return;

		// If a previous animation is still running, let the native click happen.
		if (answer.dataset.animating === '1') return;

		e.preventDefault();
		answer.dataset.animating = '1';

		var onEnd = function () {
			answer.removeEventListener('transitionend', onEnd);
			answer.style.height = '';
			delete answer.dataset.animating;
		};

		if (item.hasAttribute('open')) {
			// Close: lock current height, force reflow, animate to 0, then remove `open`.
			answer.style.height = answer.scrollHeight + 'px';
			answer.offsetHeight; // reflow
			answer.style.height = '0px';
			answer.addEventListener('transitionend', function close() {
				answer.removeEventListener('transitionend', close);
				item.removeAttribute('open');
				answer.style.height = '';
				delete answer.dataset.animating;
			});
		} else {
			// Open: add `open` so contents render, measure, snap to 0, then animate up.
			item.setAttribute('open', '');
			var target = answer.scrollHeight;
			answer.style.height = '0px';
			answer.offsetHeight; // reflow
			answer.style.height = target + 'px';
			answer.addEventListener('transitionend', onEnd);
		}
	});

});


// WEBPACK FOOTER //
// ./js/app.js